import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuthTokenGetter } from '../services/api';

export const useAuthToken = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      setAuthTokenGetter(async () => {
        try {
          const token = await getAccessTokenSilently();
          return token;
        } catch (error) {
          console.error('Error getting access token:', error);
          return null;
        }
      });
      return;
    }

    setAuthTokenGetter(null);
  }, [getAccessTokenSilently, isAuthenticated]);
};







